import { Component } from '@angular/core';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { DialogService } from '../dialog.service';
import { muckpileQuery } from '@models';
import { asFiniteNumber } from '@lib/number';

export interface SelectableMuckpile extends Partial<muckpileQuery.details.Muckpile> {
  selected: boolean;
}

@Component({
  selector: 'dialog-delete-muckpile',
  templateUrl: './dialog-remove-muckpile.component.html',
  styleUrls: ['./dialog-remove-muckpile.component.scss']
})
export class DialogRemoveMuckpileComponent {
  public selectableMuckpiles: SelectableMuckpile[] = [];
  public readonly muckpiles$ = this.fragQuery.muckpiles$;
  public readonly trigger$ = this.fragQuery.trigger$;

  constructor(
    public readonly dialog: DialogService,
    public readonly fragQuery: FragQueryService,
  ) {
  }

  ngOnInit(): void {
    this.muckpiles$.subscribe(muckpiles => {
      this.selectableMuckpiles = muckpiles.map(muckpile => ({ ...muckpile, selected: false }));
    });
  }
  
  public async deleteSelectedMuckpiles(): Promise<void> {
    const selectedMuckpileIds = this.selectableMuckpiles
      .filter(muckpile => muckpile.selected)
      .map(muckpile => asFiniteNumber(muckpile.id));

    if (selectedMuckpileIds.length === 0) return;

    await this.dialog.await(this.fragQuery.deleteMuckpile(selectedMuckpileIds));
    this.trigger$.next();
    this.dialog.closeAll();
  }

  public isDeleteEnabled(): boolean {
    return this.selectableMuckpiles.some(muckpile => muckpile.selected);
  }

  public cancel(): void {
    this.dialog.closeAll();
  }
}
